import { useTranslation } from 'react-i18next';
import type { Control } from 'react-hook-form';
import { Input } from '@/components/ui/input';
import { Textarea } from '@/components/ui/textarea';
import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
} from '@/components/ui/form';

interface AddressFieldsProps {
  // eslint_disable-next-line @typescript-eslint/no-explicit-any
  control: Control<any>;
  layout?: 'person' | 'company';
}

export function AddressFields({ control, layout = 'person' }: AddressFieldsProps) {
  const { t } = useTranslation();

  if (layout === 'company') {
    return (
      <div className="grid grid-cols-2 gap-2.5">
        <FormField
          control={control}
          name="city"
          render={({ field }) => (
            <FormItem>
              <FormLabel>{t('city')}</FormLabel>
              <FormControl>
                <Input {...field} value={field.value ?? ''} />
              </FormControl>
            </FormItem>
          )}
        />
        <FormField
          control={control}
          name="region"
          render={({ field }) => (
            <FormItem>
              <FormLabel>{t('region')}</FormLabel>
              <FormControl>
                <Input {...field} value={field.value ?? ''} />
              </FormControl>
            </FormItem>
          )}
        />
        <FormField
          control={control}
          name="street"
          render={({ field }) => (
            <FormItem className="col-span-2">
              <FormLabel>{t('street')}</FormLabel>
              <FormControl>
                <Textarea {...field} value={field.value ?? ''} className="h-[100px]" />
              </FormControl>
            </FormItem>
          )}
        />
        <FormField
          control={control}
          name="building"
          render={({ field }) => (
            <FormItem>
              <FormLabel>{t('building')}</FormLabel>
              <FormControl>
                <Input {...field} value={field.value ?? ''} />
              </FormControl>
            </FormItem>
          )}
        />
        <FormField
          control={control}
          name="country"
          render={({ field }) => (
            <FormItem>
              <FormLabel>{t('country')}</FormLabel>
              <FormControl>
                <Input {...field} value={field.value ?? ''} />
              </FormControl>
            </FormItem>
          )}
        />
        <FormField
          control={control}
          name="zip"
          render={({ field }) => (
            <FormItem className="col-span-2">
              <FormLabel>{t('zipPostal')}</FormLabel>
              <FormControl>
                <Input {...field} value={field.value ?? ''} />
              </FormControl>
            </FormItem>
          )}
        />
      </div>
    );
  }

  return (
    <div className="grid grid-cols-3 gap-2.5">
      <FormField
        control={control}
        name="street"
        render={({ field }) => (
          <FormItem className="col-span-1 row-span-2 flex flex-col gap-1">
            <FormLabel>{t('street')}</FormLabel>
            <FormControl>
              <Textarea
                {...field}
                placeholder={t('enterStreetAddress')}
                className="h-full"
                rows={4}
              />
            </FormControl>
          </FormItem>
        )}
      />
      <FormField
        control={control}
        name="city"
        render={({ field }) => (
          <FormItem>
            <FormLabel>{t('city')}</FormLabel>
            <FormControl>
              <Input {...field} />
            </FormControl>
          </FormItem>
        )}
      />
      <FormField
        control={control}
        name="region"
        render={({ field }) => (
          <FormItem>
            <FormLabel>{t('regionProvince')}</FormLabel>
            <FormControl>
              <Input {...field} />
            </FormControl>
          </FormItem>
        )}
      />
      <FormField
        control={control}
        name="zip"
        render={({ field }) => (
          <FormItem>
            <FormLabel>{t('zipPostal')}</FormLabel>
            <FormControl>
              <Input {...field} />
            </FormControl>
          </FormItem>
        )}
      />
      <FormField
        control={control}
        name="country"
        render={({ field }) => (
          <FormItem>
            <FormLabel>{t('country')}</FormLabel>
            <FormControl>
              <Input {...field} />
            </FormControl>
          </FormItem>
        )}
      />
    </div>
  );
}
